export default __webpack_public_path__ + "static/media/ortho.5eb8ee1d.svg";